const TAG_CATEGORIES_ID = "tagCategories";

export { TAG_CATEGORIES_ID };
